export const CAREGIVER_GAMIFICATION_DEFAULT_SORT = {
  sortedColumn: 'date',
  sortedColumnOrder: 'descend'
}
